/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { Link } from "react-router-dom";
import { IPlace } from "../../functions/src/api/placeInterface";
import { IApi } from "../api/api";
import { AppPath } from "../paths/pathIndex";
import { PlaceInput } from "../place/placeInput";
import { PlaceMap } from "../place/placeMap";
import { EstimateDetails } from "./estimateDetails";

import "./estimate.scss";

interface IProps {
    api: IApi;
}

interface IState {
    place: IPlace | undefined;
}

export class Estimate extends React.PureComponent<IProps, IState> {
    public state: IState = {
        place: undefined,
    };

    public render() {
        const { place } = this.state;
        return (
            <div className="scpr-Estimate">
                <h5>Price Estimate</h5>

                <div className="row">
                    <div className="col s12 m8 push-m2 l10 push-l1">
                        <PlaceInput onPlaceChanged={this.handlePlaceChanged} />

                        <div className="scpr-Estimate-place-map">
                            <PlaceMap place={place} />
                        </div>

                        {this.maybeRenderPrice()}

                        {this.maybeRenderCreateRequest()}
                    </div>
                </div>
            </div>
        );
    }

    private handlePlaceChanged = (place: IPlace | undefined) => {
        this.setState({ place });
    };

    private maybeRenderPrice() {
        const { api } = this.props;
        const { place } = this.state;

        if (place == null) {
            return null;
        }

        return (
            <div className="card-panel">
                <EstimateDetails api={api} place={place} />
            </div>
        );
    }

    private maybeRenderCreateRequest() {
        const { place } = this.state;

        if (place == null) {
            return null;
        }

        const { place_id } = place;
        const createRequestPath = AppPath.of({ placeId: place_id });
        return (
            <Link
                className="btn-large waves-effect waves-light scpr-Estimate-create-request-button"
                to={createRequestPath}
            >
                Request Scaper
                <i className="material-icons right">send</i>
            </Link>
        );
    }
}
